module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.list.length) ? _c('div', {
    staticClass: "table-list"
  }, [_c('div', {
    staticClass: "split-area"
  }), _vm._v(" "), _c('h4', [_vm._v("风险不匹配产品订单")]), _vm._v(" "), (_vm.list.length) ? _c('div', {
    staticClass: "table-view"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "list-item",
      on: {
        "click": function($event) {
          _vm.orderDetail(item.orderId)
        }
      }
    }, [_c('div', {
      staticClass: "list-left",
      staticStyle: {
        "flex": "1"
      }
    }, [_c('div', {
      staticClass: "list-left-name"
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
      staticClass: "list-left-state"
    }, [_vm._v(_vm._s(_vm.$util.formatOrderState(item.state)))])]), _vm._v(" "), _c('div', {
      staticClass: "list-right"
    }, [_c('span', {
      staticClass: "list-right-risk"
    }, [_vm._v(_vm._s(item.newProductRisk))]), _vm._v(" "), _c('span', {
      staticClass: "list-right-look"
    }, [_c('svg', {
      staticClass: "vux-x-icon vux-x-icon-ios-arrow-right arrow-right",
      staticStyle: {
        "margin-top": "12px"
      },
      attrs: {
        "type": "ios-arrow-right",
        "size": "24",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "d": "M160 115.4L180.7 96 352 256 180.7 416 160 396.7 310.5 256z"
      }
    })])])])])
  })) : _c('div', {
    staticClass: "no-data"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("暂无数据")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    attrs: {
      "src": require("../../common/images/empty.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fc10d69"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/commom/tableList.vue
// module id = 1033
// module chunks = 1